import { connect, ConnectedProps } from 'react-redux'
import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useModalCreateProductLogic from '../../../../../../../utils/hooks/product/useModalCreateProductLogic'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'
import { GroupVatPayload } from '../../../../../../../utils/reducers/globals/groupVats'
import { ModifiedCreateProductModelType } from '../../../../../../../specificComponents/Product/types'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import NewProductSpecificPricesTable from '../../../../../../../specificComponents/Product/NewProductSpecificPricesTable'
import useModalCreateProductSpecificPricesLogic from '../../../../../../../utils/hooks/product/useModalCreateProductSpecificPricesLogic'


interface ModalCreatePackagingProps extends ModalEditComponentProps { 
    customLocation?: string
}

const ModalCreatePackaging: React.FC<ModalCreatePackagingProps & ReduxModalCreatePackaging> = ({ userPermissions, allRowData, onSubmit, groupVats, customLocation, ...rest }) => {
    const { handleOnSubmit, handleOnError } = useModalCreateProductLogic({ customLocation })
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: null, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { dataPrices, setDataPrices, beforeSubmitAddSpecificPrices } = useModalCreateProductSpecificPricesLogic({})

    const fields: FormRender<ModifiedCreateProductModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang,
                    required: true
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    required: true
                },
                {
                    name: 'reference',
                    label: t('reference', 'referencia'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'image',
                    label: t('imageProduct', 'Imagen del producto'),
                    component: 'ImageInput',
                },
                {
                    name: 'productType',
                    component: 'InputHidden',
                    value: 2
                },
            ]
        }
    ]

    return (<ModalCreateEdit fields={fields} url={'/api/app/product/createProduct'} beforeSubmit={beforeSubmitAddSpecificPrices} translations={{
        title: t('createPackaging', 'Crear Packaging'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} onSubmit={handleOnSubmit} onChangeError={handleOnError} {...rest} imagePath={['tmp']} className='notFlexAutoFormRender'>
        <div className='regular18 mb-20'>
            <TwinTrans transKey='prices'>Precios</TwinTrans>
        </div>
        <NewProductSpecificPricesTable dataPrices={dataPrices} setDataPrices={setDataPrices} />
    </ModalCreateEdit>)
}


const modalCreatePackagingDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxModalCreatePackaging = ConnectedProps<typeof modalCreatePackagingConnect>
const mapModalCreatePackagingConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const modalCreatePackagingConnect = connect(mapModalCreatePackagingConnector, modalCreatePackagingDispatch)

const modalCreatePackagingConnectLoading = withLoading(ModalCreatePackaging, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])

const ModalCreatePackagingConnect = modalCreatePackagingConnect(modalCreatePackagingConnectLoading)

export default ModalCreatePackagingConnect